// @core/api/endpoints/payment/get_entity_payment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetEntityPaymentResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Get entity payment
 * Returns the payment aspect data for any entity with payment aspect. Includes full payment status, amounts, method details, and receipt.
 */
export async function GetEntityPayment(
  target_type: string,
  target_id: string,
  options?: RequestOptions
): Promise<GetEntityPaymentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment/:target_type/:target_id`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<GetEntityPaymentResponse>(requestPath, { ...requestOptions });
}
